import { render, staticRenderFns } from "./CardCharPlatform.vue?vue&type=template&id=a0dac834&"
import script from "./CardCharPlatform.vue?vue&type=script&lang=js&"
export * from "./CardCharPlatform.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports